module.exports = __webpack_public_path__ + "img/ac34aa4.jpg";